import 'swiper/swiper-bundle.min.css';

import { ArrowLeft, ArrowRight } from '../Icons/arrows';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Autoplay, Navigation } from 'swiper';

import Astronaut from 'src/components/Illustrations/Astronaut.svg';
import React from 'react';
import { ReviewCard } from '../../components/GoogleReview';
import { Section } from '../../components/Section';
import Testimonials from 'src/data/Testimonials';
import { mediaQueries } from 'src/style/breakpoints';
import { useMediaQueries } from '../../utils/MediaQueries';
import ReviewCardSmall from './ReviewCardSmall';
import colors from 'src/style/colors';

const GoogleReviews = React.memo(({ course, withoutAvatar, isCorporatePage }) => {
  const mqs = useMediaQueries();
  SwiperCore.use([Navigation, Autoplay]);

  const swiperButtonPrev = React.useRef(null);
  const swiperButtonNext = React.useRef(null);

  const data = Testimonials();
  const reviews = data.filter((item) => item.course === course);

  return (
    <div css={{ position: 'relative', overflow: 'hidden' }}>
      {mqs.desktopUp && course === 'landingPage' ? (
        <div
          css={{
            display: 'flex',
            gap: 20,
            marginTop: 120,
            padding: '10px 0px',
          }}
        >
          {reviews.map((item) => {
            return (
              <ReviewCardSmall
                key={item.name}
                avatar={item.avatar}
                title={item.title}
                text={item.text}
                author={item.name}
              />
            );
          })}
        </div>
      ) : (
        <Section
          withoutCenteredContent={true}
          theme={course === 'landingPage' ? 'secondary' : 'primary'}
          css={{
            justifyContent: 'center',
            paddingBottom: course === 'landingPage' ? 0 : null,
            [mediaQueries.phoneOnly]: {
              height: isCorporatePage ? 615 : course === 'landingPage' ? 'auto' : 710,
              paddingBottom: course === 'landingPage' && 0,
            },
            [mediaQueries.tabletPortraitUp]: {
              height: isCorporatePage ? 670 : course === 'landingPage' ? 'auto' : 740,
              paddingTop: course === 'landingPage' ? 60 : 55,
            },
            [mediaQueries.tabletLandscapeUp]: {
              height: isCorporatePage ? 635 : course === 'landingPage' ? 'auto' : 730,
            },
            [mediaQueries.desktopUp]: {
              height: isCorporatePage ? 630 : 650,
              paddingTop: 50,
              paddingBottom: 50,
            },
          }}
        >
          <div
            css={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'row',
              '.swiper-wrapper': {
                alignItems: 'center',
              },
              // backgroundColor: 'pink',
              paddingBottom: '20px',
            }}
          >
            <Swiper
              direction={'horizontal'}
              navigation={{
                prevEl: swiperButtonPrev.current,
                nextEl: swiperButtonNext.current,
              }}
              autoplay={{ delay: 5000 }}
              // autoHeight
              slidesPerView={1}
              loop
              centeredSlides
              onSwiper={(swiper) => (window.swiper = swiper)}
            >
              {reviews.map((item, key) => {
                return (
                  <SwiperSlide key={key}>
                    <div
                      css={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <ReviewCard
                        avatar={item.avatar}
                        text={item.text}
                        author={item.name}
                        title={item.title}
                        withoutAvatar={withoutAvatar}
                        reviewLink={item.reviewLink}
                        course={course}
                      />
                    </div>
                  </SwiperSlide>
                );
              })}
              <div
                css={{
                  zIndex: 10,
                  position: 'absolute',
                  left: mqs.tabletLandscapeUp
                    ? null
                    : mqs.phoneOnly && course === 'landingPage'
                    ? 0
                    : mqs.phoneOnly
                    ? 10
                    : mqs.tabletPortraitUp
                    ? 20
                    : null,
                  right: mqs.tabletLandscapeUp ? '50%' : null,
                  marginRight: mqs.tabletLandscapeUp ? 740 / 2 + 15 : null,
                  top: 70,
                  bottom: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <ArrowLeft
                  ref={swiperButtonPrev}
                  mqs={mqs}
                  color={course === 'landingPage' ? colors.purpleDark : colors.lightGrey}
                  css={{
                    cursor: 'pointer',
                    padding: course === 'landingPage' ? 0 : 15,
                    paddingRight: 0,
                  }}
                />
              </div>

              <div
                css={{
                  zIndex: 10,
                  position: 'absolute',
                  left: mqs.tabletLandscapeUp ? '50%' : null,
                  right: mqs.tabletLandscapeUp
                    ? null
                    : mqs.phoneOnly && course === 'landingPage'
                    ? 0
                    : mqs.phoneOnly
                    ? 10
                    : mqs.tabletPortraitUp
                    ? 20
                    : null,
                  marginLeft: mqs.tabletLandscapeUp ? 740 / 2 + 15 : null,
                  top: 70,
                  bottom: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <ArrowRight
                  ref={swiperButtonNext}
                  mqs={mqs}
                  color={course === 'landingPage' ? colors.purpleDark : colors.lightGrey}
                  css={{
                    cursor: 'pointer',
                    padding: course === 'landingPage' ? 0 : 15,
                    paddingLeft: 0,
                  }}
                />
              </div>
            </Swiper>
          </div>
        </Section>
      )}
      {course === 'landingPage' ? null : (
        <div
          css={{
            position: 'absolute',
            bottom: -40,
            // zIndex: 3,
            width: 500,
            right: -80,
            [mediaQueries.tabletPortraitUp]: {
              width: 630,
              right: -80,
              bottom: -55,
            },
            [mediaQueries.tabletLandscapeUp]: {
              width: 700,
            },
            [mediaQueries.desktopUp]: {
              width: 760,
              right: -100,
            },
            [mediaQueries.bigDesktopUp]: {
              right: 100,
            },
          }}
        >
          <img src={Astronaut} alt="illustration astronaute" css={{ width: '100%' }} />
        </div>
      )}
    </div>
  );
});

export default GoogleReviews;
